import { X } from 'lucide-react';
import { DEFIS_QUOTA_JOUR } from '../../../utils/xpConfig';

/**
 * Fiche de lancement d'un DÉFI — extraite d'IleEleve pour être PARTAGÉE
 * entre l'archipel et la vue Sentier (une seule source, zéro divergence).
 * Purement présentationnelle : les états quota/repos sont calculés par le
 * parent, `onLancer` déclenche le défi (le parent ferme et route).
 */
function FicheDefi({ theme, matiereLabel, quotaAtteint, reposJour, defisCredites, defisTotal, onLancer, onFermer }) {
    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
            style={{ background: 'rgba(10,31,61,.82)' }}
            onClick={(e) => { if (e.target === e.currentTarget) onFermer(); }}
        >
            <div className="relative w-full max-w-[380px] rounded-3xl p-5 pt-6 text-center" style={{ background: '#fff', border: '1px solid #C9DFF0', boxShadow: '0 20px 60px rgba(0,0,0,.5)' }}>
                <button
                    onClick={onFermer}
                    aria-label="Fermer"
                    className="absolute top-3 right-3 w-7 h-7 rounded-full flex items-center justify-center"
                    style={{ background: '#EAF3FB', color: '#0A1F3D' }}
                >
                    <X className="w-4 h-4" />
                </button>

                {/* Pastille du thème (même code couleur que sur la carte) */}
                <div
                    className="mx-auto w-14 h-14 rounded-full flex items-center justify-center text-2xl mb-2"
                    style={{
                        background: reposJour
                            ? 'radial-gradient(circle at 32% 26%, #1b3f68, #0E2A4D)'
                            : quotaAtteint
                                ? 'linear-gradient(135deg,#1F9D55,#34D399)'
                                : 'linear-gradient(135deg,#F97316,#FFB938)',
                        border: '3px solid #fff',
                        boxShadow: reposJour
                            ? '0 6px 18px rgba(10,31,61,.45)'
                            : quotaAtteint ? '0 6px 18px rgba(31,157,85,.45)' : '0 6px 18px rgba(249,115,22,.5)',
                    }}
                >
                    {reposJour ? '💤' : quotaAtteint ? <span className="font-extrabold text-white">✓</span> : '⚡'}
                </div>

                <div className="text-[18px] font-extrabold leading-snug" style={{ color: '#0A1F3D', fontFamily: 'Fredoka' }}>
                    {theme.nom}
                </div>
                <div className="text-[12px] font-bold mt-0.5" style={{ color: '#4A5A6E' }}>
                    Défi · 5 questions · {matiereLabel}
                </div>

                {/* Plafond bien-être atteint : message VICTOIRE, pas de bouton de lancement */}
                {reposJour ? (
                    <p className="mt-3 text-[13px] font-bold rounded-xl px-3 py-3" style={{ background: '#FFF7E6', color: '#7C4A03' }}>
                        🔥 Waouh, {defisTotal} défis aujourd'hui !! Tu as déjà bien bossé — repose-toi et reviens demain 💤
                    </p>
                ) : (
                    <>
                        {quotaAtteint ? (
                            <p className="mt-3 text-[12px] font-bold rounded-xl px-3 py-2" style={{ background: '#EAF9F0', color: '#166B3E' }}>
                                ✅ Tes 5 défis du jour sont gagnés ! Tu peux t'entraîner, mais sans XP aujourd'hui.
                            </p>
                        ) : (
                            <p className="mt-3 text-[12px] font-bold rounded-xl px-3 py-2" style={{ background: '#FFF4E8', color: '#9A4B0F' }}>
                                ⚡ Défis du jour : {Math.min(defisCredites, DEFIS_QUOTA_JOUR)}/{DEFIS_QUOTA_JOUR} — chaque bonne réponse rapporte de l'XP !
                            </p>
                        )}

                        <button
                            type="button"
                            onClick={onLancer}
                            className="w-full mt-4 py-3 rounded-2xl text-[15px] font-extrabold text-white active:translate-y-[2px] transition-all"
                            style={quotaAtteint
                                ? { background: '#2D7FF9', borderBottom: '4px solid #1E5FC4', fontFamily: 'Fredoka' }
                                : { background: 'linear-gradient(120deg,#F97316,#FFB938)', borderBottom: '4px solid #D98A0E', fontFamily: 'Fredoka' }}
                        >
                            {quotaAtteint ? 'S\'entraîner quand même' : '⚡ Lancer le défi !'}
                        </button>
                    </>
                )}
            </div>
        </div>
    );
}

export default FicheDefi;
